import React from 'react';
import { FileCode, Lightbulb, History } from 'lucide-react';

/**
 * Секция для специальных налоговых вычетов и льгот
 */
const SpecialDeductionsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Lightbulb className="w-5 h-5 mr-2 text-blue-500" />
        Специальные вычеты и льготы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Расходы на НИОКР */}
        <div>
          <label htmlFor="researchAndDevelopment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <FileCode className="w-4 h-4 mr-1 text-blue-500" />
            Расходы на НИОКР
          </label>
          <input
            type="text"
            id="researchAndDevelopment"
            name="researchAndDevelopment"
            value={formData.researchAndDevelopment}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.researchAndDevelopment ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.researchAndDevelopment && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.researchAndDevelopment}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Расходы на НИОКР могут учитываться с повышающим коэффициентом 1.5
          </p>
        </div>

        {/* Инвестиционный вычет */}
        <div>
          <label htmlFor="investmentDeduction" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Lightbulb className="w-4 h-4 mr-1 text-blue-500" />
            Инвестиционный вычет
          </label>
          <input
            type="text"
            id="investmentDeduction"
            name="investmentDeduction"
            value={formData.investmentDeduction}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.investmentDeduction ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.investmentDeduction && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.investmentDeduction}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Инвестиционный налоговый вычет на основные средства (ст. 286.1 НК РФ)
          </p>
        </div>

        {/* Убытки прошлых лет */}
        <div className="col-span-full">
          <label htmlFor="lossesCarriedForward" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <History className="w-4 h-4 mr-1 text-blue-500" />
            Убытки прошлых лет
          </label>
          <input
            type="text"
            id="lossesCarriedForward"
            name="lossesCarriedForward"
            value={formData.lossesCarriedForward}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.lossesCarriedForward ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.lossesCarriedForward && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.lossesCarriedForward}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Убытки прошлых лет могут быть учтены в текущем периоде в пределах 50% налоговой базы
          </p>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Lightbulb className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              О специальных налоговых вычетах
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Согласно НК РФ, организации имеют право на различные налоговые вычеты и льготы. Расходы на НИОКР могут учитываться с коэффициентом 1.5 (ст. 262 НК РФ). Убытки прошлых налоговых периодов могут переноситься на будущее в течение 10 лет, уменьшая налоговую базу не более чем на 50% (ст. 283 НК РФ). Инвестиционный налоговый вычет позволяет уменьшить налог на затраты, связанные с приобретением основных средств (ст. 286.1 НК РФ).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialDeductionsSection;